/**
 * Запоминаем активную партию на устройстве.
 *
 * Нужно, чтобы перезагрузка страницы или сворачивание Telegram не выкидывали
 * игрока из партии: при следующем запуске возвращаемся туда же. Хранится
 * только id — всё состояние всё равно приходит с сервера.
 */
const KEY = "minigames:activeMatch";

export function rememberMatch(matchId: string): void {
  try {
    localStorage.setItem(KEY, matchId);
  } catch {
    /* приватный режим или заблокированное хранилище — не критично */
  }
}

export function recallMatch(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetMatch(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* игнорируем */
  }
}

/**
 * Какие игры человек уже видел. Нужно, чтобы подсказка поверх доски
 * показывалась при первом заходе, а потом не мешала.
 */
const SEEN_KEY = "minigames:seenGames";

export function hasSeenGame(game: string): boolean {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    return raw ? (JSON.parse(raw) as string[]).includes(game) : false;
  } catch {
    return false;
  }
}

export function markGameSeen(game: string): void {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    const list = raw ? (JSON.parse(raw) as string[]) : [];
    if (!list.includes(game)) {
      list.push(game);
      localStorage.setItem(SEEN_KEY, JSON.stringify(list));
    }
  } catch {
    /* приватный режим — подсказка просто покажется снова */
  }
}
